module.exports = __webpack_public_path__ + "static/time-445866d6efe4f1475a6e4fb054e10560.jpg";